<template>
  <div id="app">
    <div id="nav">
      <Navbar id="nav" :key="league"></Navbar>
    </div>

    <b-container fluid>
      <div id="container-mid">
        <b-row>
          <b-col cols="2">
            <b-form-select
              class="dropdown"
              v-model="league"
              :options="options"
            ></b-form-select>
            <vert_navbar class="vertbar"></vert_navbar>
            <b-link to="privacy">Privacy</b-link> <br />
            <b-link to="impressum">Impressum</b-link>
          </b-col>
          <b-col cols="10" id="view">
            <div v-if="!smallScreen">
              <router-view :key="league" :smallScreen="smallScreen" />
            </div>
            <div v-else>
              <router-view :key="league" :smallScreen="smallScreen" />
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import Navbar from "./components/navbar";
import vert_navbar from "./components/vertical_navbar";
import isMobile from "./mixins/mobileCheck";
export default {
  name: "App",
  components: {
    Navbar,
    vert_navbar,
  },
  mixins: [isMobile],
  mounted: function() {
    var subdomain = window.location.host.split(".")[1]
      ? window.location.host.split(".")[0]
      : false;
    if (subdomain === "private") {
      this.league = "Conflux Heist Season (PL11169)";
      this.options = [
        { value: "Conflux Heist Season (PL11169)", text: "Conflux" },
      ];
    }
    window.addEventListener("resize", this.myEventHandler);
    this.myEventHandler();
  },
  data() {
    return {
      dropdown: "Affliction",
      league: "Affliction",
      // league = value, text = shown
      options: [
        { value: "Affliction", text: "Affliction" },
        { value: "Hardcore Affliction", text: "Hardcore Affliction" },
        { value: "Standard", text: "Standard" },
        { value: "Hardcore", text: "Hardcore" },
        { value: "Ruthless", text: "Ruthless" },
        { value: "Hardcore Ruthless", text: "Hardcore Ruthless" },
        { value: "Ruthless Affliction", text: "Ruthless Affliction" },
        {
          value: "Hardcore Ruthless Affliction",
          text: "Hardcore Ruthless Affliction",
        },
      ],
      smallScreen: false,
    };
  },
  methods: {
    changeDropdown(val) {
      this.league = val.value;
      this.dropdown = val.text;
    },
    myEventHandler() {
      if (this.isMobile()) {
        this.smallScreen = true;
      } else {
        this.smallScreen = false;
      }
    },
  },
  watch: {
    smallScreen: function() {
      //  console.log("change")
    },
  },
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

html {
  width: 100%;
  min-height: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

body {
  background-color: #2a2f35;
  width: 100%;
  min-height: 100%;
  overflow-x: hidden;
  padding-bottom: 1rem;
}

#container-mid {
  margin-top: 2%;
}

.vertbar {
  padding-right: 0;
  padding-left: 0;
  padding-top: 0;
  padding-bottom: 0;
}

.dropdown {
  background-color: var(--dark);
}
.dropdown a {
  color: white;
}
.dropdown:focus {
  color: white;
  background-color: var(--dark);
}
.dropdown a:hover {
  color: #42b983;
  background-color: var(--dark);
}

#nav {
  a {
    font-weight: bold;
    color: #bdd3e9;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.custom-select {
  color: #bdd3e9;
  background: var(--dark)
    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='white' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e")
    no-repeat right 0.75rem center/8px 10px !important;
}
::-webkit-scrollbar {
  width: 8px; /* 1px wider than Lion. */
  /* This is more usable for users trying to click it. */
  background-color: rgba(0, 0, 0, 0);
  -webkit-border-radius: 100px;
}
/* hover effect for both scrollbar area, and scrollbar 'thumb' */
::-webkit-scrollbar:hover {
  background-color: rgba(0, 0, 0, 0.09);
}

/* The scrollbar 'thumb' ...that marque oval shape in a scrollbar */
::-webkit-scrollbar-thumb:vertical {
  /* This is the EXACT color of Mac OS scrollbars.
     Yes, I pulled out digital color meter */
  background: rgba(0, 0, 0, 0.5);
  -webkit-border-radius: 100px;
}
::-webkit-scrollbar-thumb:vertical:active {
  background: rgba(0, 0, 0, 0.61); /* Some darker color when you click it */
  -webkit-border-radius: 100px;
}

.form-control:focus {
  color: darkgrey;
}
.SearchBar {
  background-color: #22262b;
  border-radius: 8px;
  display: flex;
  align-items: center;
}

#SearchInput {
  background-color: transparent;
  border-color: transparent;
  padding-left: 38px;
}
.SearchIcon {
  position: absolute;
  line-height: 38px;
  padding: 0 11px;
  box-sizing: initial;
}
</style>
